<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              :frame="true"
              v-bind="card"
              :features="true"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-bookshelf',
          title: 'Buchhaltung',
          text: '',
        },
        {
          icon: 'mdi-account-convert',
          title: 'Personalwesen',
          text: '',
        },
        {
          icon: 'mdi-offer',
          title: 'Unternehmensberatung',
          text: '',
        },
        {
          icon: 'mdi-cash-refund',
          title: 'Steuerberatung',
          text: '',
        },
      ],
    }),
  }
</script>
